import * as React from "react";
import { connect } from "react-redux";
import CustomLink from "../common/CustomLink";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";


class HeaderLoggedOut extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.HeaderLoggedOut.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let homePage = { to: { pathname: "/" } };

        return (
            <div className="container-fluid header-loggedout-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row align-items-center">
                            <div className="col-3 header__logo" style={{ display: 'none' }}>
                                <CustomLink linkProps={{ ...homePage }}>
                                    <img alt="MyBSWHealth" className="bswh-header-logo--desktop" src="/images/mybswlogo.svg" />
                                    <img alt="MyBSWHealth" className="bswh-header-logo--mobile" src="/images/bswh_logo.svg" />
                                </CustomLink>
                            </div>
                            <div className="col-9 header__signin">
                                <Link className="btn btn-primary" to={{ pathname: "/login" }}>
                                    SIGN IN
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderLoggedOut;